"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralRewardsModel = void 0;
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var interfaces_1 = require("@dp-instant/interfaces");
var interfaces_2 = require("../../interfaces");
var core_1 = require("@dp-instant/core");
var StatePending = "pending";
var track = function (name, v, p) {
    var _a;
    if (v === void 0) { v = 1; }
    return (_a = (0, core_1.lazyGet)(interfaces_1.TypesAnalytics.tracker)) === null || _a === void 0 ? void 0 : _a.track("social_rf_" + name, v, p);
};
var ReferralRewardsModel = (function () {
    function ReferralRewardsModel() {
        this._items = [];
    }
    ReferralRewardsModel_1 = ReferralRewardsModel;
    ReferralRewardsModel.prototype.init = function (defaultItemsCount) {
        if (defaultItemsCount === void 0) { defaultItemsCount = 3; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var irewards, newFriends, itemsToGenerate, pendingItems, rf, item;
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (process.env.NODE_ENV === "development") {
                            window.v_ireward = this;
                        }
                        return [4, this.social.cookie.get(ReferralRewardsModel_1.COOKIE_KEY)];
                    case 1:
                        irewards = (_b.sent()).irewards;
                        newFriends = this.social.friends.filter(function (f) { return f.isNew; }).map(function (f) { return f.id; });
                        this._items = irewards || [];
                        if (this.generateNext) {
                            itemsToGenerate = defaultItemsCount - this._items.length;
                            if (itemsToGenerate > 0) {
                                (_a = this._items).push.apply(_a, tslib_1.__spreadArray([], tslib_1.__read(new Array(itemsToGenerate).fill(0).map(function () { return ({ value: _this.generateNext() }); })), false));
                            }
                        }
                        pendingItems = this._items.filter(function (reward) { return reward.rf === StatePending; });
                        while (newFriends.length) {
                            rf = newFriends.pop();
                            item = pendingItems.pop();
                            if (item) {
                                item.rf = rf;
                            }
                        }
                        this.postData();
                        return [2, this];
                }
            });
        });
    };
    ReferralRewardsModel.prototype.request = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var popupStatus;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.social.invite({
                            filters: ["NEW_PLAYERS_ONLY"],
                            maxSize: 2
                        }, true)];
                    case 1:
                        popupStatus = _a.sent();
                        track("request_attempt");
                        if (popupStatus === interfaces_2.SOCIAL_POPUP.ACCEPTED) {
                            track("request");
                            this._request(data, StatePending);
                            this.postData(true);
                            return [2, true];
                        }
                        return [2, false];
                }
            });
        });
    };
    ReferralRewardsModel.prototype.claim = function (rf) {
        if (rf) {
            for (var i = 0; i < this._items.length; i++) {
                if (this._items[i].rf === rf) {
                    this._items.splice(i, 1);
                    this.postData();
                    track("claim");
                    return true;
                }
            }
        }
        return false;
    };
    Object.defineProperty(ReferralRewardsModel.prototype, "items", {
        get: function () {
            return this._items;
        },
        enumerable: false,
        configurable: true
    });
    ReferralRewardsModel.prototype.getPendingItems = function () {
        return this._items
            .filter(function (r) { return !r.rf || r.rf === StatePending; })
            .sort(function (r1, r2) {
            if (r1.rf === StatePending) {
                return 1;
            }
            else {
                return -1;
            }
        });
    };
    ReferralRewardsModel.prototype.getAvailableItems = function () {
        return this._items.filter(function (r) { return !!r.rf && r.rf !== StatePending; });
    };
    ReferralRewardsModel.prototype._request = function (data, rf) {
        if (rf && rf !== StatePending) {
            for (var i = 0; i < this._items.length; i++) {
                if (this._items[i].rf === rf) {
                    return this._items[i];
                }
            }
        }
        var item = this._items.filter(function (i) { return i.value === data; })[0];
        if (item) {
            item.rf = rf;
        }
        else {
            item = { value: data, rf: rf };
            this._items.push(item);
        }
        this.postData();
        return item;
    };
    ReferralRewardsModel.prototype.postData = function (force) {
        if (force === void 0) { force = false; }
        this.social.cookie.save(ReferralRewardsModel_1.COOKIE_KEY, this._items, force ? 0 : undefined);
    };
    var ReferralRewardsModel_1;
    ReferralRewardsModel.COOKIE_KEY = "irewards";
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesSocial.model),
        tslib_1.__metadata("design:type", Object)
    ], ReferralRewardsModel.prototype, "social", void 0);
    ReferralRewardsModel = ReferralRewardsModel_1 = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], ReferralRewardsModel);
    return ReferralRewardsModel;
}());
exports.ReferralRewardsModel = ReferralRewardsModel;
//# sourceMappingURL=ReferralRewardsModel.js.map